import React from 'react';
import { Field, ErrorMessage } from 'formik';

/**
 * Reusable TimeField component with Formik integration
 * Handles time input with consistent styling
 * 
 * @param {Object} props - Component props
 * @param {string} props.name - Formik field name
 * @param {string} props.label - Field label text
 * @param {boolean} props.required - Whether field is required (shows red asterisk)
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Whether field is disabled
 * @param {Function} props.onChange - Custom onChange handler (optional)
 */
const TimeField = ({
  name,
  label,
  required = false,
  placeholder = "Select time",
  className = "",
  disabled = false,
  onChange = null,
  max
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name} className="form-label">
        {required && <span style={{ color: "red", fontSize: "20px" }}>*</span>}
        {label}
      </label>
      
      <div className="input-group">
        <span className="input-group-text">
          <i className="fa fa-clock"></i>
        </span>
        
        <Field name={name}>
          {({ field, form }) => (
            <input
              type="time"
              id={name}
              className={`form-control input-width ${className}`}
              disabled={disabled}
              placeholder={placeholder}
              value={field.value || ''}
              max={max}
              
              onChange={(e) => {
                let timeValue = e.target.value;
                
                if (max && timeValue > max) {
                  timeValue = max;
                }
                
                // Set the value in Formik
                form.setFieldValue(name, timeValue);
                
                // Call custom onChange if provided
                if (onChange) {
                  onChange(timeValue, field, form);
                }
              }}
              
              onBlur={() => form.setFieldTouched(name, true)}
            />
          )}
        </Field>
      </div>
      
      <ErrorMessage name={name} component="div" className="text-danger" />
    </div>
  );
};

export default TimeField;